import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage, ref } from "firebase/storage";
import {
  getAuth,  
  signInWithEmailAndPassword,
  signOut,
  GoogleAuthProvider, 
  signInWithPopup,
  sendPasswordResetEmail

} from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBaJFsHGebBglHZiiv7zLGaeIfXQkuMiFg",
    authDomain: "lagoon-saas.firebaseapp.com",
    projectId: "lagoon-saas",
    storageBucket: "lagoon-saas.appspot.com",
    messagingSenderId: "1015309886894",
    appId: "1:1015309886894:web:d6fdd04f46bf4ae57f943f",
    measurementId: "G-N9SV1RJWK1"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
export const storage = getStorage(app);

//### LOGIN USER WITH FIREBASE ###//
export const loginUser = (email, password) => {
  const auth = getAuth();
  return signInWithEmailAndPassword(auth, email, password);
};

//### SIGN IN WITH GOOGLE ###//
export const signInWithGoogle = () => {
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  return signInWithPopup(auth, provider);
};

//### LOGOUT USER ###//
export const logoutUser = () => {
  const auth = getAuth();
  signOut(auth).then(() => {
    
  }).catch((error) => {
    
    const errorCode = error.code;
    console.log(errorCode);
  });
};

export const firebaseAuth = getAuth();
export default db;
export const config = firebaseConfig;
